module.exports = __webpack_public_path__ + "img/9788971997062.6a035e00.jpg";